import { Divider, Typography } from "@mui/material";

import { GqlMedia } from "~/__generated__";
import FileUploaderStatus from "~/modules/media/components/FileUploaderStatus";
import MediaList from "~/modules/media/components/MediaList/MediaList";

type Props = {
    title: string;
    caption: string;
    descriptionField: React.ReactNode;
    medias: GqlMedia[];
    onUploadFinished: (files: GqlMedia[]) => void;
    onMediaClick: (media: GqlMedia) => void;
};

export default function PlannerAreaAudienceSpecificSection({
    title,
    caption,
    descriptionField,
    medias,
    onUploadFinished,
    onMediaClick,
}: Props) {
    return (
        <>
            <Divider>{title}</Divider>
            <Typography variant="caption">{caption}</Typography>
            {descriptionField}
            <FileUploaderStatus onUploadFinished={onUploadFinished} />
            <MediaList medias={medias} onMediaClick={onMediaClick} />
        </>
    );
}
